import { useBreakpointValue } from "./use-breakpoint-value";

// TODO: switch to 'react-device-detect'
export const useIsMobile = () => useBreakpointValue(true, { md: false });
